import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useConfirmModalStore = defineStore('confirmModal', () => {
  const isOpen = ref(false)
  const title = ref('Confirm')
  const message = ref('')
  const confirmText = ref('Confirm')
  const cancelText = ref('Cancel')
  const confirmButtonClass = ref('btn-primary')

  let resolvePromise: ((value: boolean) => void) | null = null

  function confirm(options: {
    title?: string
    message: string
    confirmText?: string
    cancelText?: string
    type?: 'primary' | 'danger'
  }): Promise<boolean> {
    title.value = options.title || 'Confirm'
    message.value = options.message
    confirmText.value = options.confirmText || 'Confirm'
    cancelText.value = options.cancelText || 'Cancel'
    confirmButtonClass.value = options.type === 'danger' ? 'btn-danger' : 'btn-primary'

    isOpen.value = true

    return new Promise((resolve) => {
      resolvePromise = resolve
    })
  }

  function handleConfirm() {
    isOpen.value = false
    if (resolvePromise) {
      resolvePromise(true)
      resolvePromise = null
    }
  }

  function handleCancel() {
    isOpen.value = false
    if (resolvePromise) {
      resolvePromise(false)
      resolvePromise = null
    }
  }

  return {
    isOpen,
    title,
    message,
    confirmText,
    cancelText,
    confirmButtonClass,
    confirm,
    handleConfirm,
    handleCancel
  }
})
